var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
var matchWindowMedia = function (query) {
    if (typeof window === 'object' && window.matchMedia) {
        return window.matchMedia(query).matches;
    }
    return false;
};
export function executeMediaQuery(queries) {
    var matches = {};
    Object.keys(queries).forEach(function (media) {
        var query = queries[media];
        matches[media] = typeof query === 'string' ? matchWindowMedia(query) : query;
    });
    return matches;
}
var Media = /** @class */ (function (_super) {
    __extends(Media, _super);
    function Media(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            matches: {},
            matchers: {},
            keys: [],
        };
        _this.updateMatches = function () {
            return _this.setState(function (_a) {
                var keys = _a.keys, matchers = _a.matchers, matches = _a.matches;
                return ({
                    matches: keys.reduce(function (acc, key) {
                        acc[key] = matchers[key].matches;
                        return acc;
                    }, __assign({}, matches)),
                });
            });
        };
        if (typeof window !== 'object' || !window.matchMedia) {
            return _this;
        }
        var queries = props.queries;
        var keys = Object.keys(queries);
        _this.state.keys = keys;
        Object.keys(queries).forEach(function (media) {
            var query = queries[media];
            if (typeof query === 'string') {
                _this.state.matches[media] = (_this.state.matchers[media] = window.matchMedia(query)).matches;
            }
            else {
                _this.state.matches[media] = query;
            }
        });
        return _this;
    }
    Media.prototype.componentDidMount = function () {
        var _this = this;
        var matchers = this.state.matchers;
        Object.keys(matchers).forEach(function (match) { return matchers[match].addListener(_this.updateMatches); });
    };
    Media.prototype.componentWillUnmount = function () {
        var _this = this;
        var matchers = this.state.matchers;
        Object.keys(matchers).forEach(function (match) { return matchers[match].removeListener(_this.updateMatches); });
    };
    Media.prototype.render = function () {
        var children = this.props.children;
        var matches = this.state.matches;
        return children(matches);
    };
    return Media;
}(React.Component));
export { Media };
